import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-profile',
  templateUrl: './icon-profile.component.html',
  styles: []
})
export class IconProfileComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
